import { faDiceD6, faFileInvoice, faGlobe, faLandMineOn, faMobile, faPaperclip, faPenToSquare, faTags } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const features_one = [
    {
      id: 1,
      icon: <FontAwesomeIcon icon={faGlobe} />,
      title: 'Automated Payroll Processing',
      description: 'Pay contractors and employees on time, every time, with our fully automated payroll system.',
    },
    {
      id: 2,
      icon: <FontAwesomeIcon icon={faLandMineOn} />,
      title: 'Stay Compliant with Ease',
      description: 'Simplify global compliance and tax calculations to ensure youre always meeting local legal requirements.',
    },
    {
      id: 3,
      icon: <FontAwesomeIcon icon={faMobile} />,
      title: 'Boost Contractor Engagement',
      description: 'Create meaningful relationships with contractors using our tools for communication and collaboration.',
    },
  ];

const features_two = [
    {
      id: 4,
      icon: <FontAwesomeIcon icon={faGlobe} />,
      title: 'Scale Your Team Seamlessly',
      description: 'Easily expand or reduce your workforce based on project needs with our flexible workforce management platform..',
    },
    {
      id: 5,
      icon: <FontAwesomeIcon icon={faLandMineOn} />,
      title: 'Effortless Payroll Automation',
      description: 'Pay contractors and employees on time, every time, with our fully automated payroll system..',
    },
    {
      id: 6,
      icon: <FontAwesomeIcon icon={faMobile} />,
      title: ' Secure Data Storage',
      description: 'Keep your business data secure with industry-leading encryption and cloud-based storage solutions.',
    },
    {
        id: 7,
        icon: <FontAwesomeIcon icon={faMobile} />,
        title: 'Flexible Billing',
        description: 'Simplify invoicing and payment processes with flexible billing options tailored to contractors and clients.',
    },
  ];
const features_three = [
{
    id: 8,
    icon: <FontAwesomeIcon icon={faGlobe} />,
    title: 'Real-Time Analytics',
    description: 'Access live data and insightful reports to make informed decisions about staffing, project needs, and overall productivity in real time.',
},
{
    id: 9,
    icon: <FontAwesomeIcon icon={faLandMineOn} />,
    title: 'Efficient Payroll',
    description: 'Seamlessly manage global payments and taxes.',
},
{
    id: 10,
    icon: <FontAwesomeIcon icon={faMobile} />,
    title: 'Make Smarter Decisions with Analytics',
    description: 'Access real-time data and performance reports to make informed decisions about staffing and project management.',
},
{
    id: 11,
    icon: <FontAwesomeIcon icon={faMobile} />,
    title: 'Fast & Efficient Onboarding',
    description: 'Simplify the onboarding process with automated workflows that quickly guide new employees and contractors through essential steps like document submission and account setup.',
},
{
    id: 12,
    icon: <FontAwesomeIcon icon={faMobile} />,
    title: 'Global Onboarding Support',
    description: 'Manage a global workforce effortlessly with our platform’s support for multiple languages, currencies, and country-specific compliance, making onboarding easy across borders.',
},
{
    id: 13,
    icon: <FontAwesomeIcon icon={faMobile} />,
    title: 'Paperless Onboarding',
    description: 'Eliminate paperwork with fully digital forms, contracts, and agreements, saving time and reducing errors while ensuring compliance with digital signatures.',
},

];

const features_four = [
    {
      id: 14,
      icon: <FontAwesomeIcon icon={faGlobe} />,
      title: 'Local Compliance Checks',
      description: 'Compliance with local regulations, including tax, social security, and labor laws in each country or region.',
    },
    {
      id: 15,
      icon: <FontAwesomeIcon icon={faLandMineOn} />,
      title: 'Timesheet Management',
      description: 'Real-time tracking of hours worked, simplifying the process for managing contracts and projects in different time zones and regions.',
    },
    {
      id: 16,
      icon: <FontAwesomeIcon icon={faMobile} />,
      title: 'Multi-Country Support',
      description: 'Flexibility to handle contractors and employees in any country, including global support for remote teams and international expansion',
    },
    {
        id: 17,
        icon: <FontAwesomeIcon icon={faMobile} />,
        title: 'Automated Payroll',
        description: 'Precise payroll management that adapts to different tax systems, currencies, and employment standards, ensuring timely and accurate payments..',
    },
  ];

const featuresEor_three = [
  {
    id: 18,
    icon: <FontAwesomeIcon icon={faGlobe} />,
    title: 'Hassle-Free Onboarding',
    description: 'We onboard your global employees, making sure all paperwork is compliant with local laws.',
  },
  {
    id: 19,
    icon: <FontAwesomeIcon icon={faLandMineOn} />,
    title: 'Effortless Payroll & Benefits',
    description: 'We take care of payroll, taxes, and benefits while ensuring compliance across borders.',
  },
  {
    id: 20,
    icon: <FontAwesomeIcon icon={faMobile} />,
    title: 'Ongoing Support',
    description: 'Our team of local experts is always on hand to provide support and answer your questions, offering you peace of mind.',
  }
];
const featuresCont_three = [
  {
    id: 21,
    icon: <FontAwesomeIcon icon={faGlobe} />,
    title: 'Paperless Onboarding',
    description: 'Quickly onboard and offboard freelancers or contractors to meet the needs of your business.',
  },
  {
    id: 22,
    icon: <FontAwesomeIcon icon={faLandMineOn} />,
    title: 'Electronic Worker Verification',
    description: 'Ensure that all contractors meet local regulations before they start work.',
  },
  {
    id: 23,
    icon: <FontAwesomeIcon icon={faMobile} />,
    title: 'Timesheet Management',
    description: 'Track working hours and manage contracts through one system.',
  },
  {
    id: 30,
    icon: <FontAwesomeIcon icon={faDiceD6} />,
    title: 'Real-Time Analytics & Reporting',
    description: 'Insights into contractor performance, payroll data, and compliance status for better decision-making.',
  }
];

const featuresStaffingEor_three = [
  {
    id: 24,
    icon: <FontAwesomeIcon icon={faGlobe} />,
    title: 'Global Compliance',
    description: 'Ensures full compliance with local labor laws and regulations across 40+ countries.',
  },
  {
    id: 25,
    icon: <FontAwesomeIcon icon={faLandMineOn} />,
    title: 'Payroll Management',
    description: 'Handles accurate and timely payroll processing, including tax deductions.',
  },
  {
    id: 26,
    icon: <FontAwesomeIcon icon={faPaperclip} />,
    title: 'Benefits Administration',
    description: 'Manages employee benefits and statutory contributions.',
  },
  {
    id: 27,
    icon: <FontAwesomeIcon icon={faMobile} />,
    title: 'Contractor Onboarding',
    description: 'Streamlines the onboarding process with legal documentation and support.',
  },
  {
    id: 28,
    icon: <FontAwesomeIcon icon={faPenToSquare} />,
    title: 'Risk Mitigation',
    description: 'Minimizes risks associated with international hiring through local expertise.',
  },
  {
    id: 29,
    icon: <FontAwesomeIcon icon={faFileInvoice} />,
    title: 'Effortless Scaling',
    description: 'Enables fast and compliant workforce expansion without the need for setting up local entities.',
  }
];

const featuresStaffingIndependentdata = [
  {
    id: 30,
    icon: <FontAwesomeIcon icon={faGlobe} />,
    title: 'Global Compliance Assurance',
    description: 'Ensure full compliance with local employment laws and tax regulations across 40+ countries.',
  },
  {
    id: 31,
    icon: <FontAwesomeIcon icon={faLandMineOn} />,
    title: 'No Need for Local Entities',
    description: 'Manage contractors internationally without the need to establish a local presence or entity.',
  },
  {
    id: 32,
    icon: <FontAwesomeIcon icon={faMobile} />,
    title: 'Streamlined Onboarding & Offboarding',
    description: 'Efficient and paperless onboarding and offboarding processes for contractors.',
  },
  {
    id: 33,
    icon: <FontAwesomeIcon icon={faFileInvoice} />,
    title: 'Timely Payroll Management ',
    description: 'Handle contractor payments on time, in full compliance with local requirements.',
  }
];
export  { features_one , features_two , features_three, features_four ,featuresEor_three,featuresCont_three , featuresStaffingEor_three, featuresStaffingIndependentdata};